export const SIDEBAR_OVERLAY_TRIGGER_ATTR = 'data-sidebar-panel-overlay-trigger';
export const SIDEBAR_OVERLAY_TRIGGER_VALUE = 'true';
export const SIDEBAR_OVERLAY_OPEN_ATTR = 'data-sidebar-panel-overlay-open';
export const SIDEBAR_OVERLAY_OPEN_VALUE = 'true';
export const SIDEBAR_PANEL_NAV_HOVER_ATTR = 'data-sidebar-panel-nav-hover';
export const SIDEBAR_PANEL_NAV_HOVER_VALUE = 'true';

export const SIDEBAR_OVERLAY_TRIGGER_PROPS = {
  [SIDEBAR_OVERLAY_TRIGGER_ATTR]: SIDEBAR_OVERLAY_TRIGGER_VALUE,
} as const;

export function getSidebarPanelOverlayTriggerProps(isSidebarPanelEnabled = false) {
  return isSidebarPanelEnabled ? SIDEBAR_OVERLAY_TRIGGER_PROPS : {};
}

export function getSidebarPanelOverlayOpenProps(options: {
  isSidebarPanelEnabled?: boolean;
  isOpen: boolean;
}) {
  if (!options.isSidebarPanelEnabled || !options.isOpen) {
    return {};
  }

  return {
    [SIDEBAR_OVERLAY_OPEN_ATTR]: SIDEBAR_OVERLAY_OPEN_VALUE,
  } as const;
}
